import React from "react";
import CategoriasModule from "./secciones/CategoriasModule";

export default function Categorias() {
  return <CategoriasModule section="categorias" />;
}
